export default "__VITE_ASSET__EFF0qi4G__"